// ** React Imports
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// ** Redux & Store & Actions
import { connect, useDispatch } from "react-redux";
import { setActiveTab } from "store/modules/auth";

// ** Third Party Components
import { useTranslation } from "react-i18next";
import { toast } from "helpers/toastWrapper";

// ** Custom Components
import Block from "components/layout/Block";
import { RecoverButtonStyled } from "containers/Landing/styles/RecoverButton.styled";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";

// ** Utils & Helpers
import api from "helpers/ApiClient";

// #####################################################

const Recover = ({ loading, whileRecover }) => {
	const { t } = useTranslation(["landing"]);

	const dispatch = useDispatch();
	const [currentStep, setCurrentStep] = useState("first");
	const [emailRecover, setEmailRecover] = useState("");

	const location = useLocation();

	useEffect(() => {
		if (location.state?.activeLast === true) {
			api.put("/authorization/remember/verify", {
				id: location.state?.id,
				hash: location.state?.hash,
				chk: location.state?.chk,
			})
				.then(() => {
					setCurrentStep("third");
				})
				.catch((error) => {
					toast.error(error?.response?.data?.error);
					setCurrentStep("first");
				});
			delete location.state?.activeLast;
		}
	}, []);

	// #####################################################

	return (
		<>
			{currentStep === "first" ? (
				<Step1
					loading={loading}
					whileRecover={whileRecover}
					currentStep={currentStep}
					setCurrentStep={setCurrentStep}
					setEmailRecover={setEmailRecover}
				/>
			) : null}
			{currentStep === "second" ? (
				<Step2
					loading={loading}
					whileRecover={whileRecover}
					currentStep={currentStep}
					setCurrentStep={setCurrentStep}
					emailRecover={emailRecover}
				/>
			) : null}
			{currentStep === "third" ? (
				<Step3
					loading={loading}
					whileRecover={whileRecover}
					currentStep={currentStep}
				/>
			) : null}
			<Block flex justifyEnd mt={4}>
				<RecoverButtonStyled
					onMouseDown={() => dispatch(setActiveTab("login"))}
				>
					{t("landing:recover.goToLogin")}
				</RecoverButtonStyled>
			</Block>
		</>
	);
};

// #####################################################

const mapStateToProps = ({ auth: { loading, whileRecover } }) => ({
	loading,
	whileRecover,
});

export default connect(mapStateToProps, null)(Recover);

// #####################################################
